module.exports = __webpack_public_path__ + "static/media/close.8e8df68a.svg";